import { useState } from 'react';

import { getConsentCookie, setConsentCookie } from './lib/consentCookies';
import { grantGtagConsent } from './lib/gtag';

export enum ConsentState {
  PENDING = 'pending',
  GRANTED = 'granted',
}

export const useCookiesConsent = () => {
  const [cookieState, setCookieState] = useState<string | undefined>(
    checkInitialConsentState,
  );

  // TODO RB: change to accept flexible permissions
  const updateConsent = (isAccepted: boolean) => {
    const consent = isAccepted ? 'granted' : 'denied';
    grantGtagConsent({
      ad_personalization: consent,
      ad_storage: consent,
      ad_user_data: consent,
      analytics_storage: consent,
    });
  };

  const acceptCookies = () => {
    setCookieState(ConsentState.GRANTED);
    setConsentCookie({
      ad_personalization: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      analytics_storage: 'granted',
    });
    updateConsent(true);
  };

  const rejectCookies = () => {
    setCookieState(ConsentState.GRANTED);
    setConsentCookie({
      ad_personalization: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      analytics_storage: 'denied',
    });
    updateConsent(false);
  };

  return {
    cookieState,
    onAcceptCookies: acceptCookies,
    onRejectCookies: rejectCookies,
  };
};

function checkInitialConsentState() {
  const consent = getConsentCookie();
  if (consent != null) {
    return ConsentState.GRANTED;
  }

  return ConsentState.PENDING;
}
